import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GhostProvider } from '../ghost/ghost';
import { AngularFireDatabase } from 'angularfire2/database';
import { Post } from '../../models/ghost/Post';
import { Observable } from 'rxjs/Observable';
import moment from 'moment';
import { LoadingController, ModalController } from 'ionic-angular';
import { GlossaryDefinitionComponent } from '../../components/glossary-definition/glossary-definition';

/*
  Generated class for the PulseProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PulseProvider {

    constructor(
        public http: HttpClient,
        public db: AngularFireDatabase,
        public ghost: GhostProvider,
        public loadingCtrl: LoadingController,
        public modalCtrl: ModalController,

    ) {
        console.log('Hello PulseProvider Provider');
    }

    public async addPost(post: Post): Promise<any>{
        return this.db.database.ref('pulse').push(post);
    }

    /**
     * Use the ID instead of using this post for the most up to date
     */
    public getAllPosts(): Observable<Post[]>{
        return this.db.list<Post>('pulse', ref => ref.orderByChild('timestamp'))
            .snapshotChanges()
                .map(snapshot => {
                    let posts = [];
                    for (let snap of snapshot) {
                        const post: Post = snap.payload.val();
                        posts.push(post)
                        // console.log(liveSignal.key);
                    }
                    return posts.reverse();
                }).catch((error, caught) => {
                    console.log(error);
                    return Observable.of([]);
                });
    }
    
    public async openPost(slug: string){
        let loader = this.loadingCtrl.create();
        loader.present();
        try {
            let post = await this.ghost.getPostBySlug(slug).first().toPromise();
            let params = { 
                post: post, 
                title: `Pulse: ${moment(post.published_at).format('MMMM Do YYYY')}`,
                class: 'pulse'
            }
            const modal = this.modalCtrl.create(GlossaryDefinitionComponent, params);
            modal.present(); 
        } catch (error) {
            console.log(error);   
        } finally {
            loader.dismiss();
        }
    }

}



// WEBPACK FOOTER //
// ./src/providers/pulse/pulse.ts